import _ from "lodash";
import {LOGO_IMAGE_DETAIL} from "../constants/shopify.constant";

export {
    processProductListSEODetail,
    prepareSEOTitle,
}

const processProductListSEODetail = (productsList, designDetail) => {
    const metaDescriptionList = designDetail?.meta?.descriptionList || [];

    _.forEach(productsList, (product, index) => {
        prepareSEOTitle(product, designDetail);
        prepareProductDescription(product, metaDescriptionList, index);
    });
}

const prepareSEOTitle = (product, designDetail) => {
    const seoTitleList = [];
    const variantNumber = (_.split(product.title, product.designName))[1];

    let parentProductName = _.replace(designDetail.parent, 'All-Over Print', '');
    parentProductName = _.replace(parentProductName, "Batch 01", "");
    parentProductName = _.replace(parentProductName, "Batch 02", "");
    parentProductName = _.replace(parentProductName, "Batch 03", "");

    // seoTitleList.push(designDetail.parent);
    seoTitleList.push(_.trim(parentProductName));
    seoTitleList.push(designDetail.quoteName + variantNumber);
    seoTitleList.push(designDetail.themeName);

    product.seo.title = _.join(seoTitleList, ' | ');
}

const prepareProductDescription = (product, metaDescriptionList, index) => {
    product.seo.description = _.trim(metaDescriptionList[index]);

    if (product?.descriptionHtml.indexOf(product.seo.description) == -1) {
        product.descriptionHtml = product.seo.description + '<br>\n<br>' + product.descriptionHtml;
    }
}
